import { createReducer } from 'service/Utils';
import { set } from 'lodash/fp';

const initialState = {
  oauthData: {},
  loadedData: {},
  merchantData: {}
};

export default createReducer(initialState, {
  AUTHORIZE_CODE: (state, payload) => {
    return { ...state, authorizeCodeData: payload };
  },
  SELECT_MERCHANT: (state, payload) => {
    return { ...state, merchantData: payload };
  },
  REQUEST_USER: (state, payload) => {
    return set(state, payload[0], payload[1]);
  }
});
